export type AdminTab = 'users' | 'cases' | 'events';

const TABS: readonly { id: AdminTab; label: string }[] = [
  { id: 'users', label: 'Brukere' },
  { id: 'cases', label: 'Saker/kilder' },
  { id: 'events', label: 'Hendelser' },
];

interface AdminTabsProps {
  activeTab: AdminTab;
  counts: Record<AdminTab, number>;
  onTabChange: (tab: AdminTab) => void;
}

export function AdminTabs({ activeTab, counts, onTabChange }: AdminTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Adminseksjoner"
      className="flex w-full gap-2 overflow-x-auto rounded-lg border border-white/[0.07] bg-surface p-1"
    >
      {TABS.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`rounded-md px-4 py-2 text-sm font-medium transition-colors ${
              isActive
                ? 'bg-accent text-white'
                : 'text-text-secondary hover:bg-white/6 hover:text-text-primary'
            }`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.label}
            <span className={isActive ? 'ml-2 text-white/75' : 'ml-2 text-text-tertiary'}>
              {counts[tab.id]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
